import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "C:\\Users\\bigsa\\Desktop\\ShopAttend\\src\\contexts\\AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "C:\\Users\\bigsa\\Desktop\\ShopAttend\\src\\contexts\\LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\bigsa\\Desktop\\ShopAttend\\src\\styles\\tailwind.css");
